import BuilderModel from '~/models/tracked/builderModel'
import Guid from '~/helpers/guid'

export default class ProcessFlowStepActionJumpTo extends BuilderModel {
  to_client_id: string;
  client_id: string = Guid.create();

  get isCollectionRoot(): boolean {
    return false;
  }

  get nextSteps() {
    return [];
  }
}